import { authenticatedFetch } from '../utils/api';

const API_URL = process.env.REACT_APP_API_URL;

export interface IntakeResponse {
  questionKey: string;
  value?: string;
  values?: string[];
  numericVal?: number;
  freeText?: string;
  method?: 'tap';
}

export interface MatchingSignals {
  originCountry: string;
  hostCountry: string;
  hostCity: string;
  languages: string[];
  stressorCategories: string[];
  genderPreference: string;
  timeAbroad: string;
  situation: string;
}

export interface IntakeAIProfile {
  stressorThemes: string[];
  culturalContext: string;
  moodLevel: number;
  moodLabel: string;
  keyInsight: string;
  matchingSignals: MatchingSignals;
}

export interface TherapistMatch {
  therapistId: string;
  score: number;
  explanation: string;
  rank: number;
}

export interface IntakeProfile {
  id: string;
  status: 'pending' | 'processing' | 'completed' | 'failed';
  aiProfile?: IntakeAIProfile;
  matches?: TherapistMatch[];
  therapists?: any[]; // Full therapist objects from backend
}

export const submitIntake = async (
  responses: IntakeResponse[]
): Promise<{ intakeId: string; status: string }> => {
  const response = await authenticatedFetch(`${API_URL}/api/intake/submit`, {
    method: 'POST',
    body: JSON.stringify({ responses }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to submit intake');
  }

  return response.json();
};

export const fetchIntakeProfile = async (): Promise<IntakeProfile> => {
  const response = await authenticatedFetch(`${API_URL}/api/intake/profile`);

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to fetch intake profile');
  }

  return response.json();
};
